var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4163 3.95817V7.12484L9.49967 10.2915L1.58301 7.12484V3.95817C1.58301 3.74821 1.66642 3.54684 1.81488 3.39838C1.96335 3.24991 2.16471 3.1665 2.37467 3.1665H16.6247C16.8346 3.1665 17.036 3.24991 17.1845 3.39838C17.3329 3.54684 17.4163 3.74821 17.4163 3.95817ZM1.58301 8.83009V15.0415C1.58301 15.2515 1.66642 15.4528 1.81488 15.6013C1.96335 15.7498 2.16471 15.8332 2.37467 15.8332H16.6247C16.8346 15.8332 17.036 15.7498 17.1845 15.6013C17.3329 15.4528 17.4163 15.2515 17.4163 15.0415V8.83009L9.49967 11.9968L1.58301 8.83009Z",
    fill: "#B0B4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.bc547ebc635a09b4cca6d6f90f0c5f48.svg";
export { ForwardRef as ReactComponent };